module.exports = __webpack_public_path__ + "static/HS-3c865b00ee6ad5f76277a5702cd2410b.jpg";